import { connect } from 'react-redux';

import { closeModal } from 'actions/modal';
import { requestDeleteContact } from 'actions/user';
import { MODAL_DELETE_RELATION } from 'types/modal';
import { getUserByIdSelector } from 'selectors/user';
import BasicModal from './index';

const mapStateToProps = (state) => {
    const { _user } = state.modal[MODAL_DELETE_RELATION];
    const user = getUserByIdSelector(state, _user);

    return {
        _user,
        firstname: user?.firstname,
        lastname: user?.lastname
    };
};

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeModal(MODAL_DELETE_RELATION)),
    onSubmit: _user => dispatch(requestDeleteContact(_user))
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicModal);
